module.exports = "# Color\n\nColor component\n\n### Description\n\nThis is just a presentational component, displaying all the color codes used\non the sandbox.\n\n### Properties\n\nN/A\n\n### Basic usage example\n\nCopy the variable or if you need the RGB go to the source file and copy the code\n\n### Source\n\nCss modules import:\n\n`@value black, grey, light-grey ... from 'styles/_colors.css';`\n"


//////////////////
// WEBPACK FOOTER
// ./src/containers/notes/ColorNotes.md
// module id = 1484
// module chunks = 0